
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss']
})
export class ConfirmationPageComponent implements OnInit {

  constructor(private location: Location,
    private router: Router,
  ) { }

  ngOnInit(): void {   
    sessionStorage.removeItem('mailSent');
     history.pushState(null, '', location.href);

  window.onpopstate = () => {
    history.pushState(null, '', location.href);
  };
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
}